export default class Form {
    constructor($form) {
        this.$form = $form;
        this.$inputs = this.$form.querySelectorAll('.form__control');
        this.$required = this.$form.querySelectorAll('[data-input-required]');
        this.$message = this.$form.querySelector('[data-error-message]');
        this.$submit = this.$form.querySelector('[data-form-submit]');

        this.updateLabelState = this.updateLabelState.bind(this);
        this.submit = this.submit.bind(this);

        this.$inputs.forEach($trigger => {
            $trigger.addEventListener('focus', this.updateLabelState);
            $trigger.addEventListener('blur', this.updateLabelState);
            $trigger.addEventListener('input', this.updateLabelState);
        });
        this.$inputs.forEach(this.updateLabelState);
        this.$form.addEventListener('submit', this.submit);
    }

    updateLabelState(eventOrInput) {
        const $input = eventOrInput.currentTarget || eventOrInput;
        const $container = $input.closest('.form__control-container');

        if (!$container) {
            return;
        }

        const hasValue = $input.value.trim() !== '';
        const isFocused = document.activeElement === $input;
        const hasVisiblePlaceholder = $input.hasAttribute('data-label-active-with-placeholder');

        $container.classList.toggle('form__control-container--label-active', hasValue || isFocused || hasVisiblePlaceholder);
    }

    submit(e) {
        if (!this.validate()) {
            e.preventDefault();
        }
    }


    validate() {
        let valid = true;

        this.$required.forEach($input => {
            $input.classList.remove('form-input--error')
            $input.parentNode.querySelector('.form-label').classList.remove('form-label--error');
        })

        this.$required.forEach($input => {
            if (($input.type === 'text' || $input.type === 'date') && !$input.value) {
                $input.classList.add('form-input--error');
                $input.parentNode.querySelector('.form-label').classList.add('form-label--error');
                valid = false;
            }

            if ($input.type === 'email' && (!$input.value || !this.validateEmail($input.value))) {
                $input.classList.add('form-input--error');
                $input.parentNode.querySelector('.form-label').classList.add('form-label--error');
                valid = false;
            }

            if ($input.type === 'checkbox' && !$input.checked) {
                $input.classList.add('form-input--error');
                $input.parentNode.querySelector('.form-label').classList.add('form-label--error');
                valid = false;
            }
        });

        if (!valid) {
            this.$message.classList.add('form__error--show');
        }

        return valid;
    }

    validateEmail(value) {
        return value.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
}
